<template>
  <div
    class="h-screen w-full flex items-center justify-center flex-col bg-gray-100 dark:bg-slate-700"
  >
    <div v-if="loading" class="text-center max-w-md px-6">
      <div class="loading-content mb-4">
        <h2>HovaStore</h2>
        <h2>HovaStore</h2>
      </div>
      <p class="text-gray-500 dark:text-gray-400 text-sm">
        Opening QuickBooks integration settings...
      </p>
    </div>

    <div v-else-if="error" class="text-center max-w-md px-6">
      <div class="mb-4 text-red-500">
        <svg
          class="w-16 h-16 mx-auto"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z"
          />
        </svg>
      </div>
      <h2 class="text-xl font-semibold text-gray-800 dark:text-gray-200 mb-2">
        QuickBooks Redirect Failed
      </h2>
      <p class="text-gray-500 dark:text-gray-400 mb-6">
        {{ error }}
      </p>
      <button
        class="px-6 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors"
        @click="$router.replace('/store')"
      >
        Go to Stores
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "QuickbooksIntegrationRedirectView",
  data() {
    return {
      loading: true,
      error: "",
    };
  },
  async mounted() {
    try {
      const queryStoreId = this.$route.query?.store_id;
      const selectedStore = this.$store.getters.getSelectedStore;
      const userStores = this.$store.getters.getUserStores || [];
      const selectedStoreId =
        typeof selectedStore === "object" && selectedStore !== null
          ? selectedStore.id
          : selectedStore;

      let targetStoreId = queryStoreId || selectedStoreId || userStores[0]?.id;

      if (!targetStoreId) {
        const storesResponse = await this.$store.dispatch("getAllUsersStore");
        const stores = storesResponse?.stores || [];
        targetStoreId = stores[0]?.id || null;
      }

      if (!targetStoreId) {
        this.$router.replace("/store/no-stores");
        return;
      }

      const parsedStoreId = parseInt(targetStoreId, 10);
      this.$store.commit(
        "SET_SELECTED_STORE",
        Number.isNaN(parsedStoreId) ? targetStoreId : parsedStoreId,
      );

      this.$router.replace({
        name: "store_settings_quickbooks",
        params: { storeId: targetStoreId },
        query: { ...this.$route.query },
      });
    } catch (error) {
      console.error("Failed to resolve QuickBooks redirect store", error);
      this.error =
        error?.response?.data?.error?.message ||
        "Unable to determine which store should receive the QuickBooks connection.";
    } finally {
      this.loading = false;
    }
  },
};
</script>